import {configFilename} from "./configFilename"

export async function resolveSiteConfig<T>(fileName = configFilename): Promise<T> {
    const response = await fetch(`/${fileName}`);
    return response.json() as Promise<T>;
}
